// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import less from 'less'
import {setLS,getLS,base,baseImg,baseVideo,delLS,allCountries} from './api/base';
import {fetch,post} from './api/index.js';
import '../src/assets/css/global.css'

import cascaderMulti from "cascader-multi";
Vue.use(cascaderMulti);
Vue.prototype.$setLS=setLS;
Vue.prototype.$getLS=getLS;     
Vue.prototype.$delLS=delLS;     
Vue.prototype.$base=base();     
Vue.prototype.$baseImg=baseImg();     
Vue.prototype.$baseVideo=baseVideo(); 
Vue.prototype.$fetch=fetch; 
Vue.prototype.$post=post; 
Vue.prototype.$allCountries=allCountries(); 
import { pcaa } from 'area-data-vue';
import 'area-linkage-vue/dist/index.css';
import AreaLinkageVue from 'area-linkage-vue';
Vue.prototype.$pcaa = pcaa;


Vue.use(AreaLinkageVue)
Vue.use(ViewUI);
Vue.use(less)
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js